import { WithOData, withOData } from "@odata/withOData";
import React, { memo, useContext } from "react";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { PermissionContext } from "../../../contexts/permissionContext/PermissionContext";
import { IDashboardTileComponentProps, ILinkTileInfo } from "../../dashboard";
import { getIcon } from "../../icon";
import { getInfoValue } from "../../smart/FieldInfo";
import { useDashboardTile } from "../hooks/useDashboardTile";
import {
    BadgeStyled,
    IconHeight,
    IconWidth,
    StyledLinkTile,
    StyledLinkTileTitle,
    StyledLinkTileTitleWrapper,
} from "./LinkTile.styles";

interface IProps extends IDashboardTileComponentProps<ILinkTileInfo>, WithOData {
}

const LinkTile: React.FC<IProps> = ({ inEditMode, info, oData, isLight }) => {
    const context = useContext(AppContext);
    const permissionContext = useContext(PermissionContext);
    const { data: count } = useDashboardTile<number>({
        getTileDataArgs: {
            prop: info.count,
            args: { context, permissionContext, oData }
        },
        enabled: !!info.count,
        skipError: true
    });

    const to = getInfoValue(info, "link", { context });
    const Icon = info.iconName && getIcon(info.iconName);

    return (
            <StyledLinkTile backgroundColor={info.backgroundColor}
                            inEditMode={inEditMode}
                            isLight={isLight}
                            to={to}>
                {Icon && (<Icon width={IconWidth} height={IconHeight}/>)}
                <StyledLinkTileTitleWrapper>
                    <StyledLinkTileTitle>{info.title}</StyledLinkTileTitle>
                </StyledLinkTileTitleWrapper>
                <BadgeStyled count={count} max={999}/>
            </StyledLinkTile>
    );
};

export default memo(withOData(LinkTile));